import './_';
import './ul.style.scss';

import btn from './btn';
import card from './card';
import col from './col';
import dialog from './dialog';
import { FormVue } from './form';
import hr from './hr';
import icon from './icon';
import load from './load';
import row from './row';
import header from './header';

export default {
  install(Vue) {
    Vue.use(btn);
    Vue.use(card);
    Vue.use(col);
    Vue.use(dialog);
    Vue.use(FormVue);
    Vue.use(hr);
    Vue.use(icon);
    Vue.use(load);
    Vue.use(row);
    Vue.use(header);
  },
};
